import { Immutable } from '@play-co/replicant';
import * as visitRuleset from './visit.ruleset';
import { visitSchema } from './visit.schema';
import { visitActions } from './visit.actions';
import { visitAsyncGetters } from './visit.asyncGetters';
import { Pet } from '../buruburu/pet';
import { visitGetters } from './visit.getters';
import { visitModifiers } from './visit.modifiers';
import { Encyclopedia } from '../encyclopedia';
import { Profile } from '../profile';
import { Social } from '../social';
import { visitMessages } from './visit.messages';
import { StripPromise } from '@play-co/replicant/lib/core/utils/TypeUtils';
import { Inventory } from '../buruburu/inventory';
import { conversationSchema } from '../conversation/conversation.schema';
import { visitProperties } from './visit.properties';
import { ReplicantModuleState } from '../utils';
import { PetStats } from '../buruburu/pet/stats';
import { VisitRecord } from './record';
import { Fate } from '../buruburu/fate';

namespace Conversation {
  export const schema = conversationSchema;
}

export type Visit = typeof Visit;
export type FriendVisitDetails = StripPromise<
  ReturnType<Visit['asyncGetters']['getPetVisitDetails']>
>;
export type { VisitDetailsData } from './visit.asyncGetters';

// eslint-disable-next-line no-redeclare
export namespace Visit {
  export const $DEPENDENCIES = {
    VisitRecord,
    Pet,
    PetStats,
    Profile,
    Social,
    Conversation,
    Encyclopedia,
    Inventory,
    Fate,
  };

  export const ruleset = visitRuleset;
  export const schema = visitSchema;
  export const properties = visitProperties;
  export const getters = visitGetters;
  export const modifiers = visitModifiers;
  export const messages = visitMessages($DEPENDENCIES);
  export const asyncGetters = visitAsyncGetters(Visit, $DEPENDENCIES);
  export const actions = visitActions(Visit, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Visit>;
  export type State = Immutable<MutableState>;
}
